/**
 * Created by M.J. van der Werf <vanderwerf@bluehorizon.nl> on 29-1-18.
 */
import React from "react";
import {FormHelperText} from "@material-ui/core";

const Message = ({question}) => (!question.valid && <FormHelperText>{question.message}</FormHelperText>);

export default Message;
